// @flow
import FormsPageActionButton from 'pages/FormsPage/FormsPageActionButton'
import * as React from 'react'
import SearchBar from 'ui/SearchBar'

type Props = {
  setFormSearch?: (string) => void,
  formSearch?: string,
  tabletMode: boolean,
  primaryAction: () => void,
  primaryActionText: string,
  primaryActionDataCy: string,
}

function FormPageHeader({
  primaryAction,
  primaryActionText,
  primaryActionDataCy,
  setFormSearch,
  formSearch,
  tabletMode,
}: Props): React.Node {
  return (
    <div className="sm:flex">
      {!tabletMode && (
        <FormsPageActionButton
          primaryAction={primaryAction}
          primaryActionDataCy={primaryActionDataCy}
          primaryActionText={primaryActionText}
        />
      )}
      <SearchBar
        className="flex-1 mb-4"
        onChange={setFormSearch}
        value={formSearch}
      />
    </div>
  )
}

export default FormPageHeader
